












import {getModule} from 'vuex-module-decorators';
import {Component, Mixins} from 'vue-mixin-decorator';

import {Notify} from '@/utils/Notify';

import SystemInfoStore from '@/store/system/SystemInfo.store';
import SystemStatsStore from '@/store/system/SystemStats.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import Widget from '@/components/Utils/Widget.vue';
import SystemStatsDiskUsage from '@/components/System/Stats/SystemStatsDiskUsage.vue';

@Component({
  components: {SystemStatsDiskUsage, Widget},
})
export default class SystemDiskUsageWidget extends Mixins<BaseComponent>(BaseComponent) {

  private statsStore: SystemStatsStore = getModule(SystemStatsStore, this.$store);

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private async mounted() {
    this.setLoading();
    try {
      await this.systemInfoStore.fetchHardwareInfo();
      await this.statsStore.fetchStats();
    } catch (error) {
      Notify.Error(this.logger, `Could not get disk usage stats`, error);
    } finally {
      this.setLoaded();
    }
  }
}
